// extracted by mini-css-extract-plugin
export default {"table":"InvoiceTable_table__qm1AU","lastRow":"InvoiceTable_lastRow__EIrX5","totalPayAmount":"InvoiceTable_totalPayAmount__ggthe","totalPayLabel":"InvoiceTable_totalPayLabel__zw35R"};